"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingSettings = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var IconToggle_1 = require("Common/IconToggle/IconToggle");
var ViewLimit_1 = require("./ViewLimit");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var IpFiltering_1 = require("./IpFiltering");
var SpringboardEngagementSettings_1 = require("./SpringboardEngagementSettings");
var SharingSettings = (0, mobx_react_1.observer)(function (_a) {
    var telemetry = _a.telemetry, projectStore = _a.projectStore, projectSharer = _a.projectSharer, officeIpAddresses = _a.officeIpAddresses, usingFeature = _a.usingFeature, getUpsellMessage = _a.getUpsellMessage;
    var _b = __read((0, react_1.useState)(""), 2), advancedSecurityUpsell = _b[0], setAdvancedSecurityUpsell = _b[1];
    var isUsingAdvancedSecurity = usingFeature(FeatureFlag_1.default.AdvancedSecurity);
    var usingSpringboard = usingFeature(FeatureFlag_1.default.ConsumerVirality) && !usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu);
    var usingRefreshedNavigation = usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu);
    var showSpringboardSettings = usingSpringboard && !usingRefreshedNavigation;
    (0, react_1.useEffect)(function () {
        function fetchUpsellMessage() {
            return __awaiter(this, void 0, Promise, function () {
                var msg;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, getUpsellMessage(FeatureFlag_1.default.AdvancedSecurity)];
                        case 1:
                            msg = _a.sent();
                            setAdvancedSecurityUpsell(msg);
                            return [2];
                    }
                });
            });
        }
        if (!isUsingAdvancedSecurity) {
            fetchUpsellMessage();
        }
    }, [isUsingAdvancedSecurity, getUpsellMessage]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IpFiltering_1.IpFiltering, { ipFilterStore: projectStore.linkStore.ipFilterStore, officeIpAddresses: officeIpAddresses, disableSetting: !isUsingAdvancedSecurity, advancedSecurityUpsellMessage: advancedSecurityUpsell }),
        react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.Search, null), label: "Findable on search engines", value: projectStore.allowIndexing, onChange: allowIndexingToggled }),
        react_1.default.createElement(IconToggle_1.IconToggle, { icon: react_1.default.createElement(icons_1.User, null), label: "Enable social share buttons", value: projectStore.enableSocialBadge, onChange: enableSocialBadgeToggled }),
        react_1.default.createElement(ViewLimit_1.ViewLimit, { linkStore: projectStore.linkStore, disableSetting: !isUsingAdvancedSecurity, advancedSecurityUpsellMessage: advancedSecurityUpsell }),
        showSpringboardSettings && react_1.default.createElement(SpringboardEngagementSettings_1.SpringboardEngagementSettings, { projectStore: projectStore })));
    function allowIndexingToggled() {
        projectSharer.setIndexing(projectStore, !projectStore.allowIndexing);
        if (projectStore.allowIndexing) {
            telemetry.trackOnly("Project Share Via Search");
        }
    }
    function enableSocialBadgeToggled() {
        projectSharer.setSocialBadge(projectStore, !projectStore.enableSocialBadge);
    }
});
exports.SharingSettings = SharingSettings;
